import CloseIcon from '@mui/icons-material/Close';
import { Stack, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import SelectTimeComponent from './selectTimeComponent';

import { IntervalsObject } from '../../../../../interfaces/meeting';
import { setCanAddInterval } from '../../../../../slices/meetings';
import { generateTimeArray } from '../helpers';

interface IntervalComponentProps {
  intervals: IntervalsObject[],
  from: string;
  setFrom: (from: string) => void;
  to: string;
  setTo: (to: string) => void;
  index: number;
  remove: (id: number) => void;
  duration: number;
  isDeleted?: boolean | null;
}


const hasOptions = (
  timeArray: string[],
  intervals: IntervalsObject[],
): boolean => {
  const allValuesExist = timeArray.every((time) =>
    intervals.some((interval) => interval.from === time && !interval.is_delete),
  );
  return allValuesExist;
};

const IntervalComponent = ({
  intervals,
  from,
  setFrom,
  to, 
  setTo,
  isDeleted,
  index, 
  remove,
  duration }: IntervalComponentProps) => {
  const dispatch = useDispatch(); 
  const [timeArray, setTimeArray] = useState<string[]>([]);

  useEffect(() => {
    setTimeArray(generateTimeArray(duration));
  }, [duration]);

  const removeIntervalHandler = () => {
    remove(index);
  };

  // SET THE VALUE OF THE END TIMESLOT TO NEXT
  const setFromHandler = (newInterval: string) => {
    setFrom(newInterval);
    const intervalIndex = timeArray?.indexOf(newInterval);
    if (intervalIndex !== -1) {
      if (intervalIndex === timeArray.length - 1) {
        setTo(timeArray[0]);
      } else {
        setTo(timeArray[intervalIndex + 1]);
      }
    }
  };

  useEffect(() => {
    if (hasOptions(timeArray, intervals)) {
      dispatch(setCanAddInterval(false));
    } else
      dispatch(setCanAddInterval(true));
  }, [timeArray, intervals, dispatch]);

  return (
    <>
      {!isDeleted &&
        <Stack direction='row' alignItems='center' gap={1}>
          <SelectTimeComponent 
            intervals={intervals}
            selected={from} 
            setSelected={setFromHandler} 
            disabled={false}
            list={timeArray}
          />
          <>-</>
          <SelectTimeComponent 
            intervals={intervals}
            selected={to} 
            setSelected={setTo} 
            disabled={true}
            list={timeArray}
            isDisabled={true}
          />
          <IconButton 
            sx={{ padding: '4px' }}
            onClick={removeIntervalHandler}
          >
            <CloseIcon/>
          </IconButton>
        </Stack>
      }
    </>
  );
};

export default IntervalComponent;